export const ERROR_PAGE_CONTAINER_TEST_ID =
  'business-profile-page-error-page-container'
